
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M8.25,23.26h-6a1.5,1.5,0,0,1-1.5-1.5V2.26A1.5,1.5,0,0,1,2.25.76H12.88a1.5,1.5,0,0,1,1.06.44l5.87,5.87a1.54,1.54,0,0,1,.44,1.19","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M12.75.76v6a1.5,1.5,0,0,0,1.5,1.5h6","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M8.17,9.62,6,12.46a.78.78,0,0,1-.55.3.77.77,0,0,1-.58-.22L3.75,11.38","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M8.17,16.37,6,19.21a.78.78,0,0,1-.55.3.77.77,0,0,1-.58-.22L3.75,18.13","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"11.25","y1":"12.76","x2":"15","y2":"12.76","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M22.63,14.88,15,22.51l-3.75.75L12,19.51l7.63-7.63a2.11,2.11,0,0,1,3,0h0A2.11,2.11,0,0,1,22.63,14.88Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])])
          )
        }
      }
    